// Translations
import accessKeyInformationForm from '../components/access-key-information-form/translations/de'

// Translation: Model > Access key manager > Access key managing dialog (German)
export default Object.freeze({
	actions: {
		cancel: '',
		create: '',
		save: ''
	},
	components: { accessKeyInformationForm },
	message: {
		text: {
			information: '',
			instructions: ''
		},
		title: ''
	},
	title: {
		creating: '',
		editing: ''
	}
})
